import { useSystemStoreWithOut } from '@/app/stores/system';

const systemStore = useSystemStoreWithOut();

const NORMAL_PING_INTERVAL = 10000; // 정상 상태일 때 10초
const SLOW_PING_INTERVAL = 3000; // 느린 상태일 때 3초
const NETWORK_TIMEOUT = 2500; // 2.5초 타임아웃
const IMAGE_URL = 'https://www.google-analytics.com/collect';

let intervalId: NodeJS.Timeout | null = null;

// 주기적 체크를 시작하는 함수
function startChecking(interval: number) {
    if (intervalId) {
        clearInterval(intervalId);
    }
    intervalId = setInterval(checkNetworkWithImagePing, interval);
}

export function initNetworkMonitoring() {
    // 초기 네트워크 상태 체크
    checkNetworkWithImagePing();

    startChecking(NORMAL_PING_INTERVAL);
}

function checkNetworkWithImagePing() {
    const startTime = performance.now();
    const img = new Image();

    const timeoutId = setTimeout(() => {
        systemStore.setIsSlowNetwork(true);
        img.src = '';
        startChecking(SLOW_PING_INTERVAL);
    }, NETWORK_TIMEOUT);

    img.onload = () => {
        systemStore.setIsSlowNetwork(false);
        startChecking(NORMAL_PING_INTERVAL);
        clearTimeout(timeoutId);
        const endTime = performance.now();
        const rtt = endTime - startTime;

        // 네트워크 정보 업데이트
        systemStore.setPingTime(Number(rtt.toFixed(2)));
    };

    img.onerror = () => {
        clearTimeout(timeoutId);
        systemStore.setIsSlowNetwork(true);
        startChecking(SLOW_PING_INTERVAL);
    };

    // 캐시 방지를 위한 쿼리 파라미터 추가
    img.src = `${IMAGE_URL}?t=${Date.now()}`;
}
